import { Injectable, OnInit } from "@angular/core";
import { MenuItem } from "primeng/api";
import { BehaviorSubject } from "rxjs";
import { menuItems } from "./menu-items";
import { Store } from "@ngxs/store";

export interface MenuItemWithId extends MenuItem {
  id: string;
  items?: MenuItemWithId[];
}

@Injectable()
export class MenuItemsProvider {

  menuItems$ = new BehaviorSubject<MenuItemWithId[]>(menuItems);

  constructor(
    private store: Store
  ) {


  }
}
